// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"95":"fddc438d","120":"2d3e74d9","856":"adf32269","860":"31ecde35"}[chunkId] + ".js";
};